import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import request from './plugins/axios.js'
import VueUeditorWrap from 'vue-ueditor-wrap';
import 'animate.css/animate.min.css';
import './assets/css/main.css'

import { Boot } from '@wangeditor/editor'
import attachmentModule from '@wangeditor/plugin-upload-attachment'
// 注册。要在创建编辑器之前注册，且只能注册一次，不可重复注册。
Boot.registerModule(attachmentModule)

createApp(App)
.use(router)
.use(ElementPlus,{locale: zhCn,})
.use(request)
.use(VueUeditorWrap)
.mount('#app')